import axios from "axios";
import config from '../../config';
// const BASE_URL = "http://3.22.188.65:8080"
const BASE_URL = config.apiUrl;

const SaveProfile = async(Token, DataProfile) => {
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin': "*/*",
            'Authorization': `Bearer ${Token}`
        },
    };

    const instance = axios.create(options);
    try {
        const response = await instance.post("/api/profile/addprofile", DataProfile); 
        return response.data;
    } catch (error) { 
        throw error.response;
    }
};

const UpdateMemeberProfile = async(Token, DataProfile) => {
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin': "*/*",
            'Authorization': `Bearer ${Token}`
        },
    };

    const instance = axios.create(options);
    try {
        const response = await instance.post("/api/profile/UpdateProfileMember", DataProfile); 
        return response.data;
    } catch (error) { 
        throw error.response;
    }
};

const ChangeCompletProfile = async(Token, userId, value) => {
    const DataPost = {
        userId: userId,
        value: value
    };
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin': "*/*",
            'Authorization': `Bearer ${Token}`
        },
    };

    const instance = axios.create(options);
    try {
        const response = await instance.post("/api/profile/changecompletProfile", DataPost); 
        return response.data;
    } catch (error) { 
        throw error.response;
    }
};

const changeDeclareHonneur = async(Token, userId, value) => {
    const DataPost = {
        userId: userId,
        value: value
    };
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin': "*/*",
            'Authorization': `Bearer ${Token}`
        },
    };

    const instance = axios.create(options);
    try {
        const response = await instance.post("/api/profile/changeDeclareHonneur", DataPost); 
        return response.data;
    } catch (error) { 
        throw error.response;
    }
};

// Ajout de la fonction pour supprimer un utilisateur
const DisableUserProfile = async (Token, userId) => {
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin': "*/*",
            'Authorization': `Bearer ${Token}` 
        },
    };

    const instance = axios.create(options);

    // Assuming you need to send a payload to disable the user
    const payload = {
        userId: userId,
        disable: false // This marks the user as disabled
    };

    try {
        // Update the endpoint to disable the user profile
        const response = await instance.put(`/rabat-zoo/utilisateur/api/update`, payload);
        return response.data;
    } catch (error) {
        // Detailed error logging
        console.error("Erreur lors de la désactivation :", error); // Display full error
        if (error.response) {
            console.error("Détails de la réponse d'erreur :", error.response.data);
            console.error("Code d'erreur :", error.response.status);
        } else {
            console.error("Erreur sans réponse :", error.message);
        }
        throw error.response || error; // Rethrow the complete error
    }
};



export { SaveProfile, ChangeCompletProfile, changeDeclareHonneur, UpdateMemeberProfile, DisableUserProfile };
